import common from './tr/common';

const tr = {
  common,
};

export default tr;